import { memo, PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import { getFormattedDate } from "../../../helpers/date-time-helper";

import "./styles.scss";

interface Props {
    title?: string;
    value?: string | number;
    href?: string;
    isDate?: boolean;
    isHour?: boolean;
    dateFormat?: string;
    titleClassName?: string;
}

const InfoField = ({
    title,
    value,
    href,
    isDate,
    isHour,
    dateFormat,
    children,
    titleClassName,
}: PropsWithChildren<Props>) => {
    const getAdjustedValue = (value) => {
        if (isDate) {
            return getFormattedDate(value, dateFormat, "-");
        } else if (isHour) {
            return getFormattedDate(value, "HH:mm A", "-");
        }

        return value;
    };

    return (
        <div className="info-field mb-4">
            {title && <h5 className={`field-title ${titleClassName}`}>{title}</h5>}
            <span className="field-value">
                {children || (
                        value === undefined
                            ? "-"
                            : (
                                href
                                    ? <Link to={href}>{getAdjustedValue(value)}</Link>
                                    : getAdjustedValue(value)
                            )
                )}
            </span>
        </div>
    );
};

export default memo(InfoField);
